import Field from './Field';
import { jsxs as _jsxs } from "react/jsx-runtime";
const FieldWithLabelAndValue = ({
  ['data-test-id']: dataTestId,
  label,
  value
}) => /*#__PURE__*/_jsxs(Field, {
  "data-test-id": dataTestId,
  children: [label, " ", value]
});
export default FieldWithLabelAndValue;